import React, { KeyboardEventHandler, useEffect } from 'react';

import CreatableSelect from 'react-select/creatable';

const components = {
	DropdownIndicator: null,
};

interface Option {
	readonly label: string;
	readonly value: string;
}

const createOption = (label: string) => ({
	label,
	value: label,
});

const GoodToHaveSkills = ({ setInputs }) => {
	const [inputValue, setInputValue] = React.useState('');

	const [value, setValue] = React.useState<readonly Option[]>([]);



	const handleKeyDown: KeyboardEventHandler = (event) => {
		if (!inputValue) return;
		switch (event.key) {
			case 'Enter':
			case 'Tab':
				setValue((prev) => [...prev, createOption(inputValue)]);
				setInputValue('');
				event.preventDefault();


		}
	};

	// converts an object to simple array
	const options = value.map(value => (value.value));
	const result = Object.values(options);



	useEffect(() => {
		setInputs((prevState: any) => {
			return ({
				...prevState,
				goodHaveSkills: result
			});
		});
	}, [setInputs, result])

	return <CreatableSelect
		// className="AddJobinput"
		components={components}
		inputValue={inputValue}
		isClearable
		isMulti
		menuIsOpen={false}
		onChange={(newValue) => setValue(newValue)}
		onInputChange={(newValue) => setInputValue(newValue)}
		onKeyDown={handleKeyDown}
		placeholder="Type something and press enter..."
		value={value}
	/>
		;
};

export default GoodToHaveSkills